import { render, staticRenderFns } from "./CompanyEmployeeLeaveAssignmentPageTable.vue?vue&type=template&id=2002854e&scoped=true&"
import script from "./CompanyEmployeeLeaveAssignmentPageTable.vue?vue&type=script&lang=js&"
export * from "./CompanyEmployeeLeaveAssignmentPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002854e",
  null
  
)

export default component.exports